enum CampaignStatus {
	Draft = 10,
	Scheduled = 50,
	Processing = 70,
	Paused = 80,
	Active = 90,
	Closed = 91,
}

export default CampaignStatus;